import { Box } from '@mui/material';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import OtaAdminTabs from './OtaAdminTabs';
import OtaChannelDetailPage from './OtaChannelDetailPage';
import OtaChannelsPage from './OtaChannelsPage';
import OtaUpdateDetailPage from './OtaUpdateDetailPage';
import OtaUpdatesPage from './OtaUpdatesPage';

const AdminOtaScene = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minWidth: 0 }}>
    <OtaAdminTabs />
    <Routes>
      <Route index element={<Navigate to="/home/admin/ota/channels" replace />} />
      <Route path="channels" element={<OtaChannelsPage />} />
      <Route path="channels/:channelName" element={<OtaChannelDetailPage />} />
      <Route path="updates" element={<OtaUpdatesPage />} />
      <Route path="updates/:id" element={<OtaUpdateDetailPage />} />
      <Route path="settings" element={<Navigate to="/home/admin/ota/channels" replace />} />
    </Routes>
  </Box>
);

export default AdminOtaScene;
